var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgTeamsMedium = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 33 32",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2749 13.8515V22.2858C12.2749 23.3155 12.5275 24.2847 12.9663 25.143H18.6795C19.4886 25.143 20.2749 24.3281 20.2749 23.5955V12.5955L19.9538 12.5715H13.5549C12.8475 12.5715 12.2749 13.1441 12.2749 13.8515",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9417 9.14282H15.5405C16.0274 10.672 17.4422 11.7863 19.1325 11.7863C19.5337 11.7863 19.912 11.7074 20.2754 11.592V10.4765C20.2754 9.74282 19.6754 9.14282 18.9417 9.14282",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2726 12.5714H23.5663L21.9731 13.8594V20.2468C21.9731 22.6183 23.8954 24.5406 26.2669 24.5406C28.6383 24.5406 30.5606 22.6183 30.5606 20.2468V13.8594C30.5606 13.1486 29.9834 12.5714 29.2726 12.5714",
    fill: "#5059C9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4179 8.57138C29.4179 10.1497 28.139 11.4285 26.5608 11.4285C24.9825 11.4285 23.7036 10.1497 23.7036 8.57138C23.7036 6.99309 24.9825 5.71423 26.5608 5.71423C28.139 5.71423 29.4179 6.99309 29.4179 8.57138",
    fill: "#5059C9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5549 12.5714H23.5663C24.2738 12.5714 24.8463 13.144 24.8463 13.8514V22.2857C24.8463 25.7577 22.0326 28.5714 18.5606 28.5714C15.0886 28.5714 12.2749 25.7577 12.2749 22.2857V13.8514C12.2749 13.144 12.8475 12.5714 13.5549 12.5714",
    fill: "#7B83EB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9189 8.00003C22.9189 10.0915 21.2241 11.7863 19.1326 11.7863C17.0412 11.7863 15.3452 10.0915 15.3452 8.00003C15.3452 5.9086 17.0412 4.21375 19.1326 4.21375C21.2241 4.21375 22.9189 5.9086 22.9189 8.00003",
    fill: "#7B83EB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5404 9.14282H18.9415C19.6752 9.14282 20.2752 9.74282 20.2752 10.4765V11.592C19.9118 11.7074 19.5335 11.7863 19.1324 11.7863C17.4421 11.7863 16.0272 10.672 15.5404 9.14282ZM12.2749 22.2858V13.8515C12.2749 13.1441 12.8475 12.5715 13.5549 12.5715H19.9538L20.2749 12.5955V23.5955C20.2749 24.3281 19.4886 25.1429 18.6795 25.1429H12.9663C12.5275 24.2846 12.2749 23.3155 12.2749 22.2858Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7989 24H4.46514C3.73257 24 3.13257 23.4 3.13257 22.6663V9.33371C3.13257 8.6 3.73257 8 4.46514 8H17.7989C18.5326 8 19.1326 8.6 19.1326 9.33371V22.6663C19.1326 23.4 18.5326 24 17.7989 24",
    fill: "#4B53BC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.767 13.2315H12.0367V20.571H10.2425V13.2315H7.49731V11.4281H14.767V13.2315Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTeamsMedium, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/teamsMedium.ecc1db59.svg";
export { ForwardRef as ReactComponent };